<template>
    <b-row>
        <b-col cols="6">
            <b-form-group label="SELECT A COLLECTION">
                <div class="dropdown-menu-projects list-unstyled">
                    <collection-dropdown :bulk-action-running="bulkActionRunning"
                                         url="/curators/collections"
                                         :auto-fetch="true"
                                         @addToCollection="handleCollectionSelected"/>
                </div>
            </b-form-group>

        </b-col>
        <b-col cols="6">
            <div v-if="selectedCollection">

                <b-button variant="primary" size="sm" @click="handleAddAssets">
                    Add assets to {{ this.selectedCollection.name }}
                </b-button>
                <div class="font-size-sm mt-1">
                    Note: your selection has {{ selectedAssets.length }} assets. Only the
                    published ones will be added to the <b>{{ this.selectedCollection.name }}</b> collection
                </div>
            </div>
        </b-col>
    </b-row>

</template>

<script>

import GeneralMixins from "../../../../mixins/GeneralMixins";
import PulseLoader from 'vue-spinner/src/PulseLoader';
import CollectionDropdown from "../../Collections/CollectionDropdown";
import CollectionMixins from "../../Collections/CollectionMixins";

export default {
  props: ['selectedAssets', 'idKey'],

  mixins: [GeneralMixins, CollectionMixins],

  components: {PulseLoader, CollectionDropdown},

  data() {
    return {
      bulkActionRunning: false,
      selectedOption: null,
      selectedCollection: null
    }
  },

  methods: {
    handleAddAssets() {
      this.updateCollectionAssets(this.selectedCollection)
    },

    handleCollectionSelected(collection) {
      this.selectedCollection = collection
    },
  },

  computed: {
    selectedAssetIds: function () {
      return this.selectedAssets.map(el => el[this.idKey])
    },
  },
}
</script>